import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ContactService } from '../../../user-admin/services/contact.service';
import { UpsaleModalService } from '../../services/upsale-modal.service';
import { constants } from 'projects/marketpro-ui/src/app/constants';
import { UserFreemium } from '../../../auth/models/user.model';

@Component({
  selector: 'mpro-upsale-modal',
  templateUrl: './upsale-modal.component.html',
  styleUrls: ['./upsale-modal.component.scss'],
})
export class UpsaleModalComponent implements OnInit {
  public form: UntypedFormGroup;
  public loading: boolean = false;

  constructor(
    public upsaleModalService: UpsaleModalService,
    private fb: UntypedFormBuilder,
    private contactService: ContactService
  ) {}

  public ngOnInit() {
    this.initializeForm();
  }

  public onModalClose() {
    this.upsaleModalService.close();
  }

  public initializeForm() {
    const userOpenToolModel: UserFreemium = JSON.parse(
      localStorage.getItem(constants.registeredUserOpenToolStorageKey)!
    );

    if (userOpenToolModel) {
      this.form = this.fb.group({
        firstName: [userOpenToolModel.firstName, Validators.required],
        lastName: [userOpenToolModel.lastName, Validators.required],
        organizationName: [
          userOpenToolModel.organizationName,
          Validators.required,
        ],
        userEmail: [
          userOpenToolModel.email,
          [Validators.required, Validators.email],
        ],
        userText: '',
      });
    } else {
      this.form = this.fb.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        organizationName: ['', Validators.required],
        userEmail: ['', [Validators.required, Validators.email]],
        userText: '',
      });
    }
  }

  public onSubmit() {
    // const contactModel: ContactModel = { ...this.form.value };
    // this.loading = true;
    // this.contactService.sendContactEmail(contactModel)
    //   .pipe(finalize(() => {
    //     this.loading = false;
    //     this.upsaleModalService.close();
    //   }))
    //   .subscribe();
  }
}
